import Vue from 'vue';
import store from "@/store";
import router from '@/router'
import config from '@/assets/js/config.js'
import '@/assets/common/js/jquery'
import {
    Loading,
    Message
} from 'element-ui';
import {
    getDGCopy
} from '@/assets/js/basis.js'

window.log = window.console.log;

let vuex = store.state;

log("%cFF - 版本 v" + config.version,
    "line-height:24px;padding:4px 10px;background:#13b5b1;color:#000;font-size:14px;font-weight:bold");

//是否是移动端
const isMobile = /Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent);

//随机数
Vue.prototype.randomNum = (Min = 0, Max = 1, num = 2) => {
    let Range = Max - Min;
    let Rand = Math.random();
    return Min + Number((Rand * Range).toFixed(num));
};

//判断是否为空
Vue.prototype.isNull = (value, zero) => {
    if (zero === 0) {
        if (val === 0) {
            return true;
        }
    } else {
        if (val === 0) {
            return false;
        }
    }
    let val = value;
    if (val == null || val == "null" || val == "" || val == "undefined" || val == undefined || JSON.stringify(val) === '{}' || JSON.stringify(val) === '[]') {
        return true;
    } else {
        let valToString = val.toString();
        let valRe = valToString.replace(/\s/g, "");
        if (valRe == "") {
            return true;
        }
        return false;
    }
};

//数组去重复
Vue.prototype.listRepeat = (arr) => {
    var tmp = [];
    for (var i in arr) {
        if (tmp.indexOf(arr[i]) == -1) {
            tmp.push(arr[i]);
        }
    }
    return tmp;
};

//数组中不同的数据
Vue.prototype.listNoRepeat = (arr1, arr2) => {
    return arr1.concat(arr2).filter((v, i, arr) => {
        return arr.indexOf(v) === arr.lastIndexOf(v);
    });
};

//获取url参数地址
Vue.prototype.getTopUrlCom = () => {
    let href = window.location.href;
    let params = href.split('?')[1];
    if (params) {
        let list = params.split('&');
        let data = {};
        list.forEach((v) => {
            let d = v.split('=');
            data[d[0]] = decodeURI(d[1]);
        });
        return data;
    } else {
        return {};
    }
};

//xml解析为JSON格式
Vue.prototype.xmlJSON = (data) => {
    //DOM解析器
    let parser = new DOMParser();
    //读取返回字符串
    let _xml = parser.parseFromString(data, "text/xml");
    //获取节点内容
    let jsonXml = _xml.getElementsByTagName("string")[0].innerHTML;
    //获得json数组
    return JSON.parse(jsonXml);
};

//msg提示
Vue.prototype.getMsg = (message, type, time) => {
    return Message({
        message: message || '服务器错误！',
        type: type || 'error',
        showClose: true,
        duration: time || 3000
    })
};

//存session
Vue.prototype.setSession = (data) => {
    let storage = window.sessionStorage;
    for (let i in data) {
        storage.setItem(i, data[i]);
    }
};

//获取session
Vue.prototype.getSession = (key) => {
    let storage = window.sessionStorage;
    return storage.getItem(key);
};

//清除session
Vue.prototype.delSession = (data) => {
    let storage = window.sessionStorage;
    for (let i of data) {
        storage.removeItem(i)
    }
};

//设置设置Cookie
Vue.prototype.setCookie = (c_name, value, expiredays) => {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
};

//获取Cookie
Vue.prototype.getCookie = (c_name) => {
    if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            let c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) c_end = document.cookie.length;
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return ""
};

//删除Cookie
Vue.prototype.delCookie = (c_name) => {
    for (let name of c_name) {
        let date = new Date();
        date.setTime(date.getTime() - 10000);
        document.cookie = name + "=v; expires=" + date.toGMTString();
    }
};

//跳转页面
Vue.prototype.getRouterPath = (path) => {
    if (path == '/viewScreen') {
        localStorage.setItem('upd', '1')
        router.push({
            path: path
        });
    } else {
        router.push({
            path: path
        });
    }
};

//副标题
Vue.prototype.getSubTil = (sel) => {
    let route = sel.$route;
    let vuex = store.state;
    vuex.subTileList = [];
    let path = route.path;
    let routePath = config.routePath;
    let FaPath = '';
    let count = 0;
    let index = 0;
    let model = 0;
    //递归 找到父级的路径
    let getChil = (list, dadPath, index) => {
        if (count) {
            return;
        }
        for (let i = 0; i < list.length; i++) {
            if (list[i].path === path) {
                FaPath = dadPath;
                model = index;
                count = 1;
            } else if (list[i].children) {
                if (list[i].children.length > 0) {
                    getChil(list[i].children, dadPath, index);
                }
            }
        }
    };
    for (let i in routePath) {
        routePath[i].map((item) => {
            if (count) {
                return;
            }
            if (item.path === path) {
                FaPath = item.path;
                model = index;
                count = 1;
            } else {
                if (item.children) {
                    getChil(item.children, item.path, index);
                }
            }
        });
        index++;
    }
    vuex.modelRoute[model] = path;
    vuex.FaPath = FaPath;
    vuex.modelType = model;
    if (typeof route.meta.title === 'string') {
        vuex.subTileList.push({
            name: route.meta.title,
            path: ''
        })
    } else {
        route.meta.title.map((item) => {
            if (typeof item === 'string') {
                vuex.subTileList.push({
                    name: item,
                    path: ''
                })
            } else {
                vuex.subTileList.push(item)
            }
        });
    }

};

//当前页面是否缓存
Vue.prototype.cacheRoute = (sel, to) => {
    let route = sel.$route;
    let vuex = store.state;
    let routePath = config.routePath;
    //查询当前路径所属id
    let count = 0;
    let index = 0;
    let model = 0;
    let path = route.path;
    //递归
    let getChil = (list, dadPath, inChil) => {
        if (count) {
            return;
        }
        for (let i = 0; i < list.length; i++) {
            if (list[i].path === path) {
                model = inChil;
                count = 1;
            } else if (list[i].children) {
                if (list[i].children.length > 0) {
                    getChil(list[i].children, dadPath, inChil);
                }
            }
        }
    };
    for (let i in routePath) {
        routePath[i].map((item) => {
            if (count) {
                return;
            }
            if (item.path === path) {
                model = index;
                count = 1;
            } else {
                if (item.children) {
                    getChil(item.children, item.path, index);
                }
            }
        });
        index++;
    }
    //查询跳转路径所属id
    let toCount = 0;
    let toIndex = 0;
    let toModel = 0;
    let toPath = to.path;
    //递归
    let getToChil = (list, dadPath, toInChil) => {
        if (toCount) {
            return;
        }
        for (let i = 0; i < list.length; i++) {
            if (list[i].path === toPath) {
                toModel = toInChil;
                toCount = 1;
            } else if (list[i].children) {
                if (list[i].children.length > 0) {
                    getToChil(list[i].children, dadPath, toInChil);
                }
            }
        }
    };
    for (let i in routePath) {
        routePath[i].map((item) => {
            if (toCount) {
                return;
            }
            if (item.path === toPath) {
                toModel = toIndex;
                toCount = 1;
            } else {
                if (item.children) {
                    getToChil(item.children, item.path, toIndex);
                }
            }
        });
        toIndex++;
    }
    if (model !== toModel) {
        route.meta.keepAlive = true;
    } else {
        route.meta.keepAlive = false;
    }
};

//禁止事件冒泡
Vue.prototype.getNoEvent = (e) => {
    e.preventDefault();
}

//待开发
Vue.prototype.DKF = (e) => {
    return Message({
        message: '等待开发！',
        type: 'info',
        showClose: true,
        duration: 3000
    })
}

//数据接入 数据准备 图表ID
Vue.prototype.getSoSet = (type, data) => {
    let storage = window.sessionStorage;
    //view_source_xy 数据接入ID
    //view_setId_xy 数据准备ID
    //view_chartsId_xy 图表ID
    if (type === 0) {
        storage.setItem('view_source_xy', data);
        storage.setItem('view_setId_xy', '');
        storage.setItem('view_chartsId_xy', '');
    } else if (type === 1) {
        storage.setItem('view_setId_xy', data);
        storage.setItem('view_chartsId_xy', '');
    } else if (type === 2) {
        storage.setItem('view_chartsId_xy', data);
    }
};

//递归对象并赋值
Vue.prototype.getDGCopy = (obj01, obj02) => {
    let obj = obj01;
    for (let i in obj01) {
        for (let j in obj02) {
            if (i === j) {
                if (typeof obj01[i] === 'object') {
                    console.log(obj01[i] )
                    if (!obj01[i]!=null) {
                        getDGCopy(obj01[i], obj02[j])
                    } else {
                        obj01[i] = obj02[j];
                    }
                } else {
                    obj01[i] = obj02[j];
                }
            }
        }
    }
    return obj;
};

Vue.prototype.downloadFile = (filename, content) => {
    if ('download' in document.createElement('a')) {
        let elink = document.createElement('a');
        elink.download = filename;
        elink.style.display = 'none';
        elink.href = content;
        document.body.appendChild(elink);
        elink.click();
        // 释放URL 对象
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink)
    }
};

// 返回47图片地址
Vue.prototype.configImgUrl = () => {
    return config.serverRequestUrl
};